"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toBigIntBE = exports.toBufferBE = void 0;
var bigint_buffer_1 = require("@trufflesuite/bigint-buffer");
Object.defineProperty(exports, "toBufferBE", { enumerable: true, get: function () { return bigint_buffer_1.toBufferBE; } });
Object.defineProperty(exports, "toBigIntBE", { enumerable: true, get: function () { return bigint_buffer_1.toBigIntBE; } });
//# sourceMappingURL=common.js.map